<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs2 md2 >
        <v-btn color="primary" dark text  @click="showEditDialog(true)">新增</v-btn>
      </v-flex>
      <!--      <v-flex xs2 md2>-->
      <!--        <v-btn color="success" @click="exportData">匯出</v-btn>-->
      <!--      </v-flex>-->
    </v-layout>
    <v-layout  mt-2>
      <v-flex xs5 sm5 md5>
        <date-picker :date.sync="startDate" />
      </v-flex>
      <v-flex xs5 sm5 md5>
        <date-picker :date.sync="endDate" />
      </v-flex>
    </v-layout>
    <v-layout xs12>
      <v-flex md2 xs8>
        <v-select :items="getSearchKeys"
                  item-text="value"
                  item-value="key"
                  v-model="search.searchKey"
                  label="查詢條件"
        ></v-select>
      </v-flex>
      <v-flex ml-2 md4 xs8>
        <v-text-field v-model="search.keyword" :label="`搜尋名稱或類型`" :placeholder="search.placeholder"
                      @keyup.enter="searchEvent"></v-text-field>
      </v-flex>
      <v-flex md4 xs4>
        <v-btn color="success" @click="searchEvent">搜尋</v-btn>
        <v-btn color="warning" @click="reset">重置</v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap mt-2>
      <v-container
        fluid>
        <table-view :columnKeys="columnKeys"
                    :items="items"
                    :loading="loading"
                    :total-items="totalItems"
                    @cellEvent="cellEvent"
                    @changePage="changePage"
                    @handleLoadData="reset">
        </table-view>
      </v-container>
    </v-layout>

    <CarFinanceDialog :visible="fileDialog.visible"
                      :title="fileDialog.title"
                      :item="fileDialog.item"
                      :isNew="fileDialog.isNew"
                      :loading="fileDialog.loading"
                      @confirmEvent="fileDialogConfirm"
                      @cancelEvent="fileDialog.visible = false"
                      @deleteEvent="deleteEvent"></CarFinanceDialog>

  </v-container>
</template>

<script>
import AlertView from '@/components/AlertView';
import TableView from '@/components/TableView';
import { mapActions, mapGetters } from 'vuex';
import DatePicker from "@/components/DatePicker";
import common from '@/mixins/common';
import CarFinanceDialog from '@/components/CarFinanceDialog';
import CarFinanceModel from '@/models/CarFinanceModel';
import { deleteCarFinanceInfo, saveCarFinanceInfo, updateCarFinanceInfo } from '@/store/actions';
export default {
  name: 'CarFinanceList',
  mixins: [common],
  components: {
    CarFinanceDialog,
    AlertView,
    TableView,
    DatePicker
  },
  props:{
    vendor: String // 0 和潤 1 中租 2 TAC
  },
  data(){
    return {
      startDate: '',
      endDate: '',
      loading: false,
      pageIndex: 1,
      limit: 50,
      totalItems: 0,
      saveLoading: false,
      search: {
        keyword: "",
        searchKey:'displayId',
      },
      items: [],
      messageDialog: {
        title: "",
        text: "",
        visible: false,
        showCancelButton: false,
        confirm: () => {},
        cancel: () => {},
      },
      fileDialog:{
        title: "",
        visible: false,
        loading: false,
        isNew:false,
        item: new CarFinanceModel(),
        confirm: () => {},
        cancel: () => {},
      },
    }
  },
  created() {
    this.setDefaultDate();
    this.loadData();
    this.fetchAgentList();
  },
  computed:{
    ...mapGetters(["getUserInfo", "getAgentList"]),
    getSearchKeys(){
      return [
        { key:'displayId', value: '案件編號' },
        { key:'name', value: '姓名' },
        { key:'memberId', value: '身份證' },
      ]
    },
    columnKeys() {
      const list = [
        { value: "edit", text: "編輯", sortable: false, required: false, color: 'primary', isEvent: true },
        { value: "displayId", text: "案件編號", sortable: true, required: false },
        { value: "name", text: "姓名", sortable: true, required: false },
        { value: "memberId", text: "身份證", sortable: true, required: false },
        {
          value: "carId",
          text: "車牌",
          sortable: true,
          required: false,
        },
        {
          value: "vendor",
          text: "招攬通路",
          sortable: true,
          required: false,
          options: [
            { key: '0', text: '和潤'},
            { key: '1', text: '中租'},
            { key: '2', text: 'TAC'}
          ],
          isSelectText: true,
        },
        {
          value: "category",
          text: "專案類型",
          sortable: true,
          required: false,
        },
        {
          value: "totalCreditPrice",
          text: "申辦金額",
          sortable: true,
          required: false,
        },
        {
          value: "creditPriceMonth",
          text: "月付金",
          sortable: true,
          required: false,
        },
        {
          value: "installmentsNumber",
          text: "期數",
          sortable: true,
          required: false,
        },
        {
          value: "agentId",
          text: "招攬通路",
          sortable: true,
          required: false,
          options: this.getAgents(),
          isSelectText: true,
        },
        { value: "createdDate", text: "建立時間", sortable: true, required: false },
        { value: "updatedDate", text: "更新時間", sortable: true, required: false }
      ];
      return list
    },
  },
  methods: {
    ...mapActions(['uploadImageData', 'fetchAgentList', 'saveCarFinanceInfo', 'getCarFinanceList' , 'updateCarFinanceInfo'
      ,'deleteCarFinanceInfo']),
    setDefaultDate() {
      let todayDate = new Date();
      todayDate.setMonth(todayDate.getMonth() - 1);
      let currentDate = todayDate.toISOString().substr(0, 10);
      const [thisYear, thisMonth, thisDay] = currentDate.split("-");
      this.startDate = `${thisYear}-${thisMonth}-01`;

      let futureDate = new Date();
      // 将当前月份加1，下移到下个月
      futureDate.setMonth(futureDate.getMonth() + 1);
      // 再获取天数即取上个月的最后一天的天数
      futureDate.setDate(0);
      let days = futureDate.getDate();

      let endDate = futureDate.toISOString().substr(0, 10);
      const [futureYear, futureMonth, futureDay] = endDate.split("-");

      this.endDate = `${futureYear}-${futureMonth}-${days}`;
    },
    getAgents(){
      const list = [];
      for (let agent of this.getAgentList){
        list.push({ key: agent.agentId, text: agent.displayName });
      }
      return list;
    },
    async loadData(){
      try {
        this.loading = true;

        let query = [
          { key: 'vendor', value: this.vendor }
        ];
        if (this.search.keyword !== ''){
          query.push({ key: this.search.searchKey, value: this.search.keyword })
        }

        const res = await this.getCarFinanceList({
          searchQuery: query,
          pageIndex: this.pageIndex,
          limit: this.limit,
          startDate: this.startDate,
          endDate: this.endDate,
          agentId: (this.isAdmin || this.isStaff) ? '': this.getUserInfo.agentId,
        });

        this.loading = false;
        const result = res.data;
        this.items = result.data.list;
        this.totalItems = result.data.header.totalCount;
      } catch (e) {
        console.log(`load error `, e);
      } finally {
        this.loading = false;
      }
    },
    showEditDialog(isNew, item){
      this.fileDialog.visible = true;
      this.fileDialog.isNew = isNew;
      if (!isNew){
        this.fileDialog.item = item;
      } else {
        this.fileDialog.item.vendor = this.vendor ? this.vendor : '0';
      }
    },
    cellEvent(props) { // cell 按鈕事件 (用Key判斷是點選哪一個
      console.log(`edit = ${JSON.stringify(props)}`)
      if (props.key === 'edit'){
        this.showEditDialog(false, props.item);
      }

    },
    changePage(page) { // 改變頁數 or 每頁筆數
      this.pageIndex = page.page;
      this.limit = page.rowsPerPage;
      this.loadData();
    },
    reset(){
      this.loadData();
    },
    searchEvent(){
      this.loadData();
    },
    async fileDialogConfirm(info){
      console.log(`save ${JSON.stringify(info)}`);
      try {
        this.fileDialog.loading = true;
        let i = 1;
        for (let file of info.files){
          const dataURL = await this.readFileAsync(file);
          const fileURL = await this.uploadData(file.name, info.item, dataURL);
          if (i <=8){
            info.item[`fileURL${i}`] = fileURL;
          }
          i++;
        }
        console.log(`upload item ${JSON.stringify(info.item)}`);


        let res;
        if (this.fileDialog.isNew){
          res = await this.saveCarFinanceInfo(info.item);
        } else {
          res = await this.updateCarFinanceInfo(info.item);
        }
        const result = res.data;
        console.log(`result ${JSON.stringify(result)}`);

        if (result.statusCode === 0 ){
          this.resetInfo();
          this.showMessageDialog(result.message);
          this.fileDialog.visible = false;
        } else {
          this.showMessageDialog( result.message);
        }
      } catch (e) {
        console.log(e);
        this.showMessageDialog('發生異常，請輸入格式是否正確');
      } finally {
        this.fileDialog.loading = false;
      }
    },
    readFileAsync(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },
    async uploadData(name, item, fileData) {
      try {
        const response = await this.$store.dispatch('uploadImageData', {
          name: `fileList/${name}`,
          image: fileData,
        });
        console.log(`upload Data success ${JSON.stringify(response)}`);
        return response;
        // 處理完成更新資料
      } catch (error) {
        console.error('Error uploading data:', error);
        return null;
      }
    },
    resetInfo(){
      this.fileDialog.visible = false;
      this.fileDialog.item = new CarFinanceModel();
      this.loadData();
    },
    async deleteEvent(caseId){
      await this.deleteInfo(caseId);
    },
    async deleteInfo(caseId){
      console.log(`delete = ${caseId}`);
      const res = await this.deleteCarFinanceInfo({
        caseId: caseId,
      });
      const result = res.data;
      console.log(`result ${JSON.stringify(result)}`);
      if (result.statusCode === 0 ){
        this.resetInfo();
        this.showMessageDialog(result.message);
      } else {
        this.showMessageDialog(result.message);
      }
    },
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CarFinanceList.vue